import { Modifier } from "components/routes/events/id/judge/modifierUtils";
import { ResultModel } from "models/Result";

export function scrollLeaderboardItemIntoView(
    athleteId: string,
    place: ReturnType<ResultModel["placeToDisplay"]>,
    modifier?: Modifier
) {
    const leaderboard = document.querySelector("#pending-leaderboard");
    const leaderboardItem = document.querySelector(getPendingLeaderboardDataAttributeSelector(athleteId, place, modifier));

    if (!leaderboard || !leaderboardItem) return;

    const containerRect = leaderboard.getBoundingClientRect();
    const containerEdge = containerRect.top;
    const selectedPlaceEdge = leaderboardItem.getBoundingClientRect().top;

    leaderboard.scrollBy({ top: selectedPlaceEdge - containerEdge - 16, behavior: "smooth" });
}

export function getPendingLeaderboardDataAttributes(
    athleteId: string,
    place: ReturnType<ResultModel["placeToDisplay"]>,
    modifier?: Modifier | null
) {
    const attrs: Record<string, string | number> = { "data-athlete": athleteId };
    if (place.type === "place" && place.place != null) attrs["data-place"] = place.place;
    if (modifier) attrs["data-modifier"] = modifier;

    return attrs;
}

export function getPendingLeaderboardDataAttributeSelector(
    athleteId: string,
    place: ReturnType<ResultModel["placeToDisplay"]>,
    modifier?: Modifier | null
) {
    const selector = [
        modifier ? `[data-modifier="${modifier}"]` : "",
        place.type === "place" && place.place != null ? `[data-place="${place.place}"]` : "",
        `[data-athlete="${athleteId}"]`,
    ].filter(Boolean).join(", ");
    
    return selector;
}
